class ExcelRequestContract {
	constructor(repSoNumber, payDatePeriodId, repFullName, isPending) {
		this.repSoNumber = repSoNumber;
		this.payDatePeriodId = payDatePeriodId;
		this.repFullName = repFullName;
		this.isPending = isPending;
	}
}

export default ExcelRequestContract;